import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isMobileApp, jsonToContentTypedBlob } from "../utils";
import request, { useSubmitTime } from "./request";
export function uploadPolicyFinderData(_x, _x2) { return _uploadPolicyFinderData.apply(this, arguments); }
function _uploadPolicyFinderData() { _uploadPolicyFinderData = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(param, proof) { var fd, reqData, result; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            fd = new FormData();
            reqData = Object.assign({ insuredName: param.insuredName, insuredSurname: param.insuredSurname, insuredIdentityValue: param.insuredIdentityValue, name: param.name, email: param.email, incidentType: param.incidentType, incidentDate: param.incidentDate, mobileNo: param.mobileNo, mobilePager: param.mobilePager, relationship: param.relationship, tnc: param.tnc, authorized: param.authorized, insuredIdentityType: param.insuredIdentityType, language: param.language, ticket: param.ticket, randStr: param.randStr, insuredTemplateType: param.insuredTemplateType, isMobileApp: isMobileApp() }, useSubmitTime());
            fd.set("files", proof);
            _context.t0 = fd;
            _context.next = 6;
            return jsonToContentTypedBlob(reqData);
        case 6:
            _context.t1 = _context.sent;
            _context.t0.set.call(_context.t0, "data", _context.t1);
            _context.next = 10;
            return request.post("/api/v1/policy/policyFinder/getInsuredInfo", fd, { headers: { "X-Inline-Error": "true" } });
        case 10:
            result = _context.sent;
            return _context.abrupt("return", result.data);
        case 12:
        case "end": return _context.stop();
    }
} }, _callee); })); return _uploadPolicyFinderData.apply(this, arguments); }
